import React, { PureComponent } from 'react';
import {
	Table,
	Spin,
	Row,
	Col,
	Button,
	Card,
	Typography,
	DatePicker,
	Select,
	Menu,
	Dropdown,
	Icon,
	Input,
	Modal,
	Form,
	message
} from 'antd';
import { numberWithSpaces } from 'src/components/Table/SearchOnField';
import styles from './styles';
import CONSTANTS from 'src/constants';
import moment from 'moment';
import ButtonExportCsvByUrl from 'src/components/Button/ButtonExportCsvByUrl';
//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getDetailRestaurantGroup, getRestaurantGroupTransactionByCreditor } from 'src/redux/actions/restaurantGroup.js';
import AuthStorage from 'src/utils/AuthStorage';
import { getTransactionsDebitorCreditorById, getTransactionHistory, cancelTransaction } from 'src/redux/actions/transactions.js';
import injectSheet from 'react-jss';
const { RangePicker } = DatePicker;
const { Text, Title } = Typography;
const { Option } = Select;
const { Search } = Input;

import { isInteger, toInteger } from 'lodash';

function mapStateToProps(state) {
	return {
		store: {
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				getDetailRestaurantGroup,
				getRestaurantGroupTransactionByCreditor,
				getTransactionsDebitorCreditorById,
				getTransactionHistory,
				cancelTransaction
			},
			dispatch
		)
	};
};
const now = new Date();
@connect(
	mapStateToProps,
	mapDispatchToProps
)
@injectSheet(styles)
export default class RestaurantDashboard extends PureComponent {
	state = {
		dataHistoryEncaissement: [],
		loading: false,
		loadingSelect: false,
		date1: '',
		date2: '',
		detail: [],
		restaurantInGroup: [],
		date1Encaissement: moment(new Date(now.getFullYear(), now.getMonth(), 1), 'DD/MM/YYYY').format('YYYY-MM-DD 00:00:00'),
		date2Encaissement: moment(new Date(now.getFullYear(), now.getMonth() + 1, 0), 'DD/MM/YYYY').format('YYYY-MM-DD 23:59:59'),
		payloadExport: {},
		dataCancel: [],
		motif: '',
		password: '',
		cancelModal: false,
		cancelNote: '',
		cancelPassword: '',
		cancelActionDisable: false
	}
	componentDidMount() {
		this.restaurantGroupHistoryEncaissement()
	}

	restaurantGroupHistoryEncaissementOld = (date1, date2, search, amount) => {
		const { userId } = AuthStorage;
		this.setState({ loading: true });
		let payload = {
			id: userId,
			'date2': date2 ? date2 : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
			'date1': date1 ? date1 : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
		}

		if (search) {
			payload['search'] = search;
		}

		if (amount) {
			payload['amount'] = amount;
		}

		let payloadExport = {
			orfilter: userId,
			'type[0]': 3,
			'type[1]': 1,
			'date[after]': date1 ? date1 : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
			'date[before]': date2 ? date2 : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
			pagination: false
		};

		this.setState({ payloadExport: payloadExport })

		this.props.action.getTransactionsDebitorCreditorById(
			payload,
			res => { this.setState({ dataHistoryEncaissement: res, loading: false }) }
		)
	}

	restaurantGroupHistoryEncaissement = (date1, date2, search, amount) => {
		const { userId, idInfo } = AuthStorage;
		let payload = {
			restaurantId: idInfo,
			'dateStart': date1 ? date1 : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
			'dateEnd': date2 ? date2 : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
		}

		if (search) {
			payload['search'] = search;
		}

		if (amount) {
			payload['amount'] = amount;
		}

		const payloadExport = {
			orfilter: userId,
			'date[after]': date1 ? date1 : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
			'date[before]': date2 ? date2 : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59')
		};

		this.setState({ payloadExport: payloadExport })

		this.setState({ loading: true }, () => {
			this.props.action.getTransactionHistory(
				payload,
				(res) => {
					this.setState({
						loading: false,
						dataHistoryEncaissement: res,
					});
				},
				() => {
					this.setState({ loading: false });
				}
			);
		});
	}

	handleFilterDate = (dataString) => {
		const date1 = dataString && dataString[0] ? moment(dataString[0], 'DD/MM/YYYY').format('YYYY-MM-DD 00:00:00') : null;
		const date2 = dataString && dataString[1] ? moment(dataString[1], 'DD/MM/YYYY').format('YYYY-MM-DD 23:59:59') : null;
		this.setState({ date1: date1, date2: date2, date1Encaissement: date1, date2Encaissement: date2 })
		dataString && dataString.length > 0 ? this.restaurantGroupHistoryEncaissement(date1, date2) : ''
	}

	cancelModalTransaction = (e) => {
		this.setState({ dataCancel: e })
		this.cancelModalVisible(true);
	}

	actionCancelTransaction = (e) => {
		const { dataCancel } = this.state;
		let id = dataCancel.id;
		let ref = dataCancel.transactionId;
		let date = dataCancel.date;
		let debitor = dataCancel.debitorInfo.userId;
		let creditor = dataCancel.creditorInfo.userId;
		let amount = dataCancel.amount;
		let noteMain = this.state.cancelNote;
		let password = this.state.cancelPassword;

		let payload = {
			id,
			ref,
			date,
			debitor,
			creditor,
			amount,
			noteMain,
			password
		}

		this.cancelTransaction(payload);
	}

	cancelTransaction = payload => {
		this.setState({ cancelActionDisable: true })
		const { id } = this.props;
		this.props.action.cancelTransaction(
			payload,
			res => {
				if (res && res.statusCode == 601) {
					message.error('Votre mot de passe est incorrect')
					this.setState({
						cancelNote: '',
						cancelPassword: '',
						cancelActionDisable: false
					})

				}
				else if (res && res.statusCode == 200) {
					message.success(res.message)
					this.restaurantGroupHistoryEncaissement();
					this.setState({
						cancelNote: '',
						cancelPassword: '',
						cancelModal: false,
						cancelActionDisable: false
					})
				}
				else {
					message.error("L'annulation de la transaction n'a pas pu être effectuée")
					this.restaurantGroupHistoryEncaissement();
					this.setState({
						cancelNote: '',
						cancelPassword: '',
						cancelModal: false,
						cancelActionDisable: false
					})
				}
			}
		);
	}

	cancelModalVisible = (e) => {
		this.setState({ cancelModal: e })
	}


	render() {
		const { isTama, isRestaurant, userId } = AuthStorage;
		const dataHistory = this.state.dataHistoryEncaissement && this.state.dataHistoryEncaissement.map(d => ({
			...d,
		}));
		let totalEncaissement = 0;
		let totalRefund = 0;
		let averageEncaissement = 0;
		let totalData = dataHistory.length;
		const columns = [
			{
				title: 'REF',
				dataIndex: 'transactionId',
				key: 'transactionId',
				sorter: (a, b) => b.transactionId - a.transactionId,
			},
			{
				title: 'Date',
				dataIndex: 'date',
				key: 'date',
				sorter: (a, b) => new Date(b.date) - new Date(a.date),
				render: value => {
					return moment(value, 'YYYY-MM-DD[T]HH:mm:ss').format('DD-MM-YYYY HH:mm:ss ');
				}
			},
			{
				title: 'Montant',
				dataIndex: '',
				key: 'amount',
				align: 'right',
				sorter: (a, b) => {
					let val1 = (a.creditType == 'CANCEL') ? a.amount * 0 : (a.creditType == 'PAYMENT' ? a.amount * -1 : ((a.creditType == 'DEBIT' && (a.debitorInfo && (a.debitorInfo.userId == userId)) ? a.amount - 1 : a.amount)));
					let val2 = (b.creditType == 'CANCEL') ? b.amount * 0 : (b.creditType == 'PAYMENT' ? b.amount * -1 : ((b.creditType == 'DEBIT' && (b.debitorInfo && (b.debitorInfo.userId == userId)) ? b.amount - 1 : b.amount)));
					return val1 - val2
				},
				render: (e, opt) => (
					<Text strong style={{
						color: opt.creditType == "PAYMENT" ? '#00c68e' : (opt.creditType == "CANCEL" ? 'orange' : 'red')
					}}>
						{
							`${opt.creditType == "PAYMENT" ? '+' : (opt.creditType == "CANCEL" ? '' : '-')}${numberWithSpaces(e.amount)} ${CONSTANTS.CURRENCY
							}`
						}
					</Text>)
			},
			{
				title: 'Note 1',
				dataIndex: 'noteMain',
				key: 'noteMain'
			},
			{
				title: 'Note 2',
				dataIndex: 'noteSub',
				key: 'noteSub',
			},
			{
				title: 'Status',
				dataIndex: '',
				key: '',
				render: (e) => {
					if (e.creditType == 'PAYMENT' && moment(e.date).format('YYYY-MM') >= moment(new Date()).format('YYYY-MM')) {
						return <Button type='link' onClick={() => this.cancelModalTransaction(e)} style={{ color: 'red' }}><Icon type="close" /> Annuler</Button>
					}
					if (e.creditType == 'CANCEL') {
						return <Text style={{ color: 'orange' }}>Annulée</Text>
					}
				}
			}
		];

		const menu = (
			<Menu >
				<Menu.Item key="CSV">
					<ButtonExportCsvByUrl url={'/get-export-credit-history-csv'} payload={this.state.payloadExport} />
				</Menu.Item>
			</Menu>
		);

		return (
			this.state.detail && (
				<>
					<Card style={{ marginBottom: 10, boxShadow: '2px 2px 10px lightgrey' }}>
						<Row gutter={24}>
							<Col span={4}>
								<Text strong>Filtrer sur une période précise: </Text>
							</Col>
							<Col span={20}>
								<RangePicker
									style={{ width: '500px' }}
									onChange={(e) => this.handleFilterDate(e)}
									value={[moment(new Date(this.state.date1Encaissement), 'DD-MM-YYYY'), moment(new Date(this.state.date2Encaissement), 'DD-MM-YYYY')]}
									format={'DD-MM-YYYY'}
									allowClear={false}
								/>
							</Col>
						</Row>
					</Card>

					<Card style={{ marginBottom: 10, boxShadow: '2px 2px 10px lightgrey' }}>
						<Row gutter={12} style={{ marginBottom: 10 }}>
							<Col span={6}>
								<Text strong></Text>
							</Col>
						</Row>

						<Row type="flex" justify="space-between" align="top">
							<Col>
								<Title level={4}>
									Historique des encaissements
								</Title>
							</Col>
							<Col>
								<Dropdown overlay={menu} trigger={['click']}>
									<Button type="link">
										<Icon type="export" /> Export
									</Button>
								</Dropdown>
							</Col>
						</Row>


						<Row gutter={24} style={{ marginBottom: 20 }}>
							<Col span={8}>
								<Card style={{ boxShadow: '2px 2px 10px lightgrey' }}>
									<Row type="flex" align="middle" justify="space-between">
										<Col>
											<Text strong>
												Total encaissé :
											</Text>
										</Col>
										<Col>
											<div style={{ float: 'right', width: '100%' }}>
												<Row>
													<Text
														style={{
															fontSize: '30px',
															borderRadius: '10px',
															color: '#16C68F',
															fontWeight: 'bold'
														}}>
														{
															dataHistory.forEach(element => {
																element.creditType == "PAYMENT" && (
																	totalEncaissement += element.amount
																);
															})
														}
														{numberWithSpaces(totalEncaissement) + " "}
														<span style={{ fontSize: '12px', padding: '0 10px' }}>
															{CONSTANTS.CURRENCY}
														</span>
													</Text>
												</Row>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>

							<Col span={8}>
								<Card style={{ boxShadow: '2px 2px 10px lightgrey' }}>
									<Row type="flex" align="middle" justify="space-between">
										<Col>
											<Text strong>
												Total remboursé :
											</Text>
										</Col>
										<Col>
											<div style={{ float: 'right', width: '100%' }}>
												<Row>
													<Text
														style={{
															fontSize: '30px',
															borderRadius: '10px',
															color: '#16C68F',
															fontWeight: 'bold'
														}}>
														{
															dataHistory.forEach(element => {
																element.creditType == "REFUND" && (
																	totalRefund += element.amount
																);
															})
														}
														{numberWithSpaces(totalRefund) + " "}
														<span style={{ fontSize: '12px', padding: '0 10px' }}>
															{CONSTANTS.CURRENCY}
														</span>
													</Text>
												</Row>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>

							<Col span={8}>
								<Card style={{ boxShadow: '2px 2px 10px lightgrey' }}>
									<Row type="flex" align="middle" justify="space-between">
										<Col>
											<Text strong>
												Montant moyen par transaction :
											</Text>
										</Col>
										<Col>
											<div style={{ float: 'right', width: '100%' }}>
												<Row>
													<Text
														style={{
															fontSize: '30px',
															borderRadius: '10px',
															color: '#16C68F',
															fontWeight: 'bold'
														}}>
														{
															totalData > 0 ? dataHistory.forEach(element => {
																averageEncaissement += element.amount;
															})
																:
																''
														}
														{numberWithSpaces(totalData > 0 ? Math.round(averageEncaissement / totalData) : 0) + " "}
														<span style={{ fontSize: '12px', padding: '0 10px' }}>
															{CONSTANTS.CURRENCY}
														</span>
													</Text>
												</Row>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>
						<Row gutter={24} type="flex" style={{ marginBottom: 20 }}>
							<Col>
								<Row>
									<Search
										allowClear
										placeholder="N° de référence"
										onChange={(e) => this.restaurantGroupHistoryEncaissement(this.state.date1Encaissement, this.state.date2Encaissement, e.target.value)}
									/>
								</Row>
							</Col>
							<Col>
								<Row>
									<Search
										allowClear
										placeholder="Montant"
										onChange={(e) => this.restaurantGroupHistoryEncaissement(this.state.date1Encaissement, this.state.date2Encaissement, null, e.target.value)}
									/>
								</Row>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Spin spinning={this.state.loading}>
									<Table
										columns={columns}
										scroll={{ y: '65vh', x: '100%' }}
										dataSource={dataHistory}
										rowKey="id"
										pagination={{
											showSizeChanger: true,
											pageSizeOptions: ['100', '500', '1000'],
											defaultPageSize: 100,
											style: { paddingRight: 50 }
										}}
									/>
								</Spin>
							</Col>
						</Row>
					</Card>

					{
						(isRestaurant) &&
						<Modal
							visible={this.state.cancelModal}
							onCancel={() => this.cancelModalVisible(false)}
							width={450}
							onOk={() => this.actionCancelTransaction()}
							okButtonProps={{ disabled: this.state.cancelActionDisable || !this.state.cancelNote || !this.state.cancelPassword }}
							style={{ textAlign: 'center' }}
							okText='ANNULER LA TRANSACTION'
							cancelText="Fermer"
						>

							<Form onSubmit={this.handleSubmit} className="login-form">
								<Row style={{ padding: 10 }}>
									<Col>
										<Text strong >Confirmer la transaction à annuler: </Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text style={{ color: '#00C68E' }}><b>REF : </b>{this.state.dataCancel.transactionId}</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text style={{ color: '#00C68E' }}><b>Date : </b>{moment(this.state.dataCancel.date).format('DD/MM/YYYY à HH:mm:ss')}</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text style={{ color: '#00C68E' }}><b>Nom : </b>{this.state.dataCancel.debitorInfo && this.state.dataCancel.debitorInfo.debitorName}</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text style={{ color: '#00C68E' }}><b>Société : </b>{this.state.dataCancel.debitorInfo && this.state.dataCancel.debitorInfo.companyName}</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text style={{ color: '#00C68E' }}><b>Montant : </b>{numberWithSpaces(toInteger(this.state.dataCancel.amount))} XPF</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text strong>Motif :</Text>
									</Col>
								</Row>
								<Row style={{ padding: 10 }}>
									<Input onChange={(e) => this.setState({ cancelNote: e.target.value })} value={this.state.cancelNote} required />
								</Row>
								<Row style={{ padding: 10 }}>
									<Col>
										<Text strong>Saisissez votre mot de passe pour lancer l'annulation:</Text>
									</Col>
								</Row>

								<Row style={{ padding: 10 }}>
									<Input.Password type={'password'} onChange={(e) => this.setState({ cancelPassword: e.target.value })} value={this.state.cancelPassword} required />
								</Row>
							</Form>
						</Modal>
					}
				</>
			)
		);
	}
}
